export function flattenObject(
  obj: unknown,
  prefix = "",
  result: Record<string, unknown> = {},
): Record<string, unknown> {
  // Guard against primitives - return as-is with prefix or empty object
  if (obj === null || typeof obj !== "object") {
    if (prefix) {
      result[prefix] = obj;
    }
    return result;
  }

  // Handle arrays with numeric indices (e.g., items.0.property)
  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      const path = prefix ? `${prefix}.${i}` : `${i}`;
      flattenObject(obj[i], path, result);
    }
    return result;
  }

  // Handle plain objects
  if (Object.getPrototypeOf(obj) === Object.prototype) {
    for (const [key, value] of Object.entries(obj)) {
      const path = prefix ? `${prefix}.${key}` : key;
      flattenObject(value, path, result);
    }
    return result;
  }

  // Non-plain objects (Date, etc.) - store as-is
  if (prefix) {
    result[prefix] = obj;
  }
  return result;
}
